import defaultIdentityFlow from "./defaultIdentity";

export default defaultIdentityFlow;